import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { STEPS } from '../constants/trainingConstants';

export default function StepNavigation({
  currentStep,
  onStepChange,
  onBackToGrid,
}) {
  return (
    <div className="w-full bg-zinc-900 p-6 rounded-md flex flex-col h-full">
      {onBackToGrid && (
        <button
          onClick={onBackToGrid}
          className="flex items-center text-gray-400 hover:text-white mb-8 text-sm transition-colors"
        >
          <ChevronLeft className="w-4 h-4 mr-1" />
          Back to Scene Editor
        </button>
      )}

      <div className="space-y-2">
        {/* Team Setup (step 3) commented out for now - do not remove */}
        {STEPS.filter((step) => step.num !== 3).map((step) => (
          <button
            key={step.num}
            onClick={() => step.num <= 5 && onStepChange(step.num)}
            className={`flex items-center rounded-lg p-3 w-full text-left transition-colors ${
              currentStep === step.num
                ? ' text-white'
                : currentStep > step.num
                  ? 'text-white hover:bg-zinc-800'
                  : 'text-gray-500'
            }`}
          >
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3 ${
                currentStep === step.num
                  ? 'bg-red-600 text-white'
                  : currentStep > step.num
                    ? 'border border-[#4ADE80] text-[#4ADE80]'
                    : 'bg-gray-700 text-gray-400'
              }`}
            >
              {currentStep > step.num ? '✓' : step.num}
            </div>
            <div className="text-xs leading-tight">
              <div
                className={`font-semibold ${currentStep === step.num ? 'text-white' : ''}`}
              >
                {step.title}
              </div>
              {step.subtitle && (
                <div
                  className={
                    currentStep === step.num ? 'text-white' : 'text-gray-500'
                  }
                >
                  {step.subtitle}
                </div>
              )}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
